export default __webpack_public_path__ + "static/media/11.1b90ab2f.jpg";